import API from '../../../../../services/api';

export const SERVICIOS_ENVIO_API = {
    new: async (servicio) => {
        return API.post('/servicios-envios', servicio).then(res => res.data);
    },
    update: async (servicio) => {
        return API.put('/servicios-envios/' + servicio.id, servicio).then(res => res.data);
    },
    delete: async (idServicio) => {
        return API.delete('/servicios-envios/' + idServicio).then(res => res.data);
    }
}